// extracted by mini-css-extract-plugin
export var activityContainer = "_kc-0";
export var typingIndicatorContainer = "_kc-1";
export var typingIndicatorDot = "_kc-2";
export var wave = "_kc-3";